import * as React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

export const TableEmptyRows: React.FC<{ emptyRows: number; dense: boolean, colSpan: number }> = (
    props
) => {
    const { emptyRows, dense, colSpan } = props;

    return (
        <>
            {emptyRows > 0 && (
                <TableRow
                    style={{
                        height: (dense ? 33 : 53) * emptyRows,
                    }}
                >
                    <TableCell colSpan={colSpan} />
                </TableRow>
            )}
        </>
    );
};
